import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'

import MailchimpForm from './MailchimpForm';
import logo from '../assets/img/logo.png'

import instagram from '../assets/img/instagram.svg'
import cv from '../assets/img/cv.svg'
import { useTranslation } from 'react-i18next';
import VisitCounter from './VisitCounter';

const GLOW_COLORS = ['#31fff5','#7c3aed','#f472b6','#fbbf24','#34d399','#60a5fa','#ff6b6b','#ffd93d'];

function Footer() {
    const { t } = useTranslation();

    const glowEnter = (e) => {
        const c1 = GLOW_COLORS[Math.floor(Math.random() * GLOW_COLORS.length)];
        const c2 = GLOW_COLORS[Math.floor(Math.random() * GLOW_COLORS.length)];
        e.currentTarget.style.setProperty('--gc1', c1);
        e.currentTarget.style.setProperty('--gc2', c2);
    };

    return (
        <footer className="footer" id="footer">
            <svg style={{position:'absolute',width:0,height:0}} aria-hidden="true">
                <filter id="smoke">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="3" result="noise"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="5" xChannelSelector="R" yChannelSelector="G"/>
                </filter>
            </svg>
            <Container>
                <Row className="align-items-center pt-4">
                    <MailchimpForm />
                    <Col size={12} sm={6} className="text-center text-sm-start">

                        <a href="#home" style={{ paddingBottom: '20px', display: 'inline-block' }}>
                            <span className="logo-glitch-wrap footer-logo-glitch">
                                <div className="efecto-glitch efecto-glitch-footer">
                                    <img src={logo} alt="Facundo Corona logo" />
                                </div>
                            </span>
                        </a>
                    </Col>
                    <Col size={12} sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                            <a className='cv' onMouseEnter={glowEnter} href={"https://docs.google.com/document/d/1CMSNlcoAW4B7SvbC50qMWawVNLgEOTuB/edit?usp=share_link&ouid=103301223346485071359&rtpof=true&sd=true"} target="_blank" rel="noopener noreferrer" title="CV"><img src={cv} alt={'CV'} width="24" height="24" loading="lazy" /></a>
                            <a className='instagram' onMouseEnter={glowEnter} href={"https://www.instagram.com/facucorona"} target="_blank" rel="noopener noreferrer" title="Instagram"><img src={instagram} alt={'Instagram'} width="24" height="24" loading="lazy" style={{ filter: 'brightness(0) invert(1)' }} /></a>
                            <a className='resume' onMouseEnter={glowEnter} href={"https://docs.google.com/document/d/1WJ0es53byr_D9pdwkSdANaJ8fp7B2P8O/edit?usp=share_link&ouid=103301223346485071359&rtpof=true&sd=true"} target="_blank" rel="noopener noreferrer" title="Resume"><img src={cv} alt={'Resume'} width="24" height="24" loading="lazy" /></a>
                        </div>
                        <p className="textfooter">
                            Copyright 2026. {t('footer.rights')}
                            <br />
                            <VisitCounter />
                        </p>
                    </Col>
                </Row>
            </Container>
            <div className="footer-bottom-decoration">.·.</div>
        </footer>
    )
}

export default Footer